import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Loader2, LockKeyhole } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { api, formatApiError } from "@/lib/api";
import Reveal from "@/components/Reveal";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const token = params.get("token") || "";
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (password !== confirm) {
      setError("Şifreler birbiriyle uyuşmuyor.");
      return;
    }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: password });
      alert("Şifreniz güncellendi. Yeni şifrenizle giriş yapabilirsiniz.");
      navigate("/giris");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="mx-auto max-w-md px-4 pt-32 pb-24">
      <Reveal>
        <span className="grid h-14 w-14 place-items-center rounded-2xl bg-emerald2 text-bone">
          <LockKeyhole size={24} />
        </span>
        <h1 className="mt-5 font-display text-3xl font-black tracking-tight">Yeni şifreni belirle</h1>
        <p className="mt-2 text-sm text-slate-500">Şifren en az 6 karakter olmalıdır.</p>
        {!token && (
          <p className="mt-4 rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">
            Geçersiz bağlantı. Lütfen sıfırlama bağlantısını tekrar talep edin.
          </p>
        )}
        <form onSubmit={submit} className="mt-8 space-y-4" data-testid="reset-password-form">
          <div className="space-y-2">
            <Label htmlFor="np">Yeni Şifre *</Label>
            <Input id="np" data-testid="new-password-input" required type="password" minLength={8} value={password} onChange={(e) => setPassword(e.target.value)} />
            <p className="text-[11px] text-slate-400">En az 8 karakter olmalı ve harf + rakam içermelidir.</p>
          </div>
          <div className="space-y-2">
            <Label htmlFor="cp">Yeni Şifre (Tekrar) *</Label>
            <Input id="cp" data-testid="confirm-password-input" required type="password" minLength={6} value={confirm} onChange={(e) => setConfirm(e.target.value)} />
          </div>
          {error && <p data-testid="reset-error-message" className="rounded-xl border border-red-200 bg-red-50 px-4 py-3 text-sm text-red-600">{error}</p>}
          <Button data-testid="reset-password-submit-button" type="submit" disabled={busy || !token} className="w-full rounded-full bg-coral py-3.5 text-sm font-bold text-white hover:bg-coraldark transition">
            {busy ? <Loader2 size={17} className="animate-spin" /> : "Şifremi Güncelle"}
          </Button>
          <p className="text-center text-sm text-slate-500">
            <Link to="/giris" className="font-bold text-coral hover:underline">Girişe dön</Link>
          </p>
        </form>
      </Reveal>
    </div>
  );
}
